import { render, staticRenderFns } from "./ErrorBase.vue?vue&type=template&id=97cbd484"
import script from "./ErrorBase.vue?vue&type=script&lang=js"
export * from "./ErrorBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports